/**
 * Cube registry — one entry per draggable panel on the desktop canvas.
 *
 * 1.0.B ships two cubes (Buyers / Closed Sales). Phase 2+ adds
 * Incoming Feed, Reply Composer, Live Thread, Tonight's Schedule, etc.
 *
 * Geometry: 12-col grid; cellHeight 36px (LayoutManager). h:14 ≈ 504px.
 */
import { type TemplateResult } from "lit-html";
import { renderPipelineCube }       from "../components/PipelineCube";
import { renderClosedSalesCube }    from "../components/ClosedSalesCube";
import { renderScheduleCube }       from "../components/ScheduleCube";
import { renderArchivedCube }       from "../components/ArchivedCube";
import type { AppState } from "../data/store";

export interface CubeGeometry { x: number; y: number; w: number; h: number }

export interface CubeDef {
  id: string;
  defaultGeometry: CubeGeometry;
  render: (state: AppState) => TemplateResult;
  /** Disable Gridstack resize handles on this widget. */
  noResize?: boolean;
  minW?: number;
  maxW?: number;
  minH?: number;
  maxH?: number;
}

export const CUBES: CubeDef[] = [
  {
    id: "pipeline",
    defaultGeometry: { x: 0, y: 0, w: 8, h: 18 },
    render: renderPipelineCube,
  },
  {
    id: "closed-sales",
    defaultGeometry: { x: 8, y: 0, w: 4, h: 18 },
    render: renderClosedSalesCube,
  },
  {
    id: "schedule",
    // Schedule used to share its row with the preview at x:0,w:8.
    // Now that the preview moved into a dedicated right rail (2.O),
    // the canvas is full-width — schedule and closed-sales fill it.
    defaultGeometry: { x: 0, y: 18, w: 8, h: 18 },
    render: renderScheduleCube,
  },
  {
    id: "archived",
    // Archived buyers (FEST-PHASE-2.P). Lives in the bottom-right of
    // the canvas; users open it occasionally to restore. Keep it
    // compact until populated.
    defaultGeometry: { x: 8, y: 18, w: 4, h: 18 },
    render: renderArchivedCube,
  },
];
